import React, { Component } from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import { Formik } from 'formik';
import _ from 'lodash';
import config from '../config';
import JsonEditorComponent from '../JsonEditorComponent'
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {downloadFile, readFileAsync} from "../components/ImportExport";

export default class Versions extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {serverVersion: 0};
        this.init = this.init.bind(this);
        this.exportObj = this.exportObj.bind(this);
        this.createStorageVersion = this.createStorageVersion.bind(this);
        this.upload = this.upload.bind(this);
        this.applyToServer = this.applyToServer.bind(this);
        this.remove = this.remove.bind(this);
        this.init();
    }

    async init()  {

        let versionsJson = await fetcher(`${config.API()}storage/versions/get`);
        let objects = await versionsJson.json()

        let srvJson = await fetcher(`${config.API()}storage/version`);
        let srvObj = await srvJson.json()
        let serverVersion = srvObj.serverId;

        let changesJson = await fetcher(`${config.API()}storage/changes`)
        this.changes = await changesJson.json()

        for(let o of objects){
            o.changes = _.filter(this.changes, x => x.adminVersion == o.fromVersion);
            o.notSavedChanges = _.filter(this.changes, x => x.adminVersion == o.version);
        }
        console.log(objects);
        this.setState({
            objects,
            serverVersion: serverVersion
        })
    }

    remove = (version) => (e) => {
        let isOk = window.confirm("Are you sure?");
        if(!isOk)
            return;
        fetcher(`${config.API()}storage/versions/remove`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({version})
        })
            .then(response => response.json())
            .then(data => {
                let objects = this.state.objects;
                _.remove(objects, x => x.version == version)
                this.setState({objects})
            });
    }

    createStorageVersion() {
        fetcher(`${config.API()}storage/versions/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body:JSON.stringify({})
        })
        .then(response => response.json())
        .then(data => {
            this.init();
        });
    }

    applyToServer = (version) => (e) => {
        let isOk = window.confirm("Are you sure? The server will start using this version of the settings");
        if(!isOk)
            return;
        fetcher(`${config.API()}storage/versions/apply`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({version})
        })
            .then(response => response.json())
            .then(data => {
                this.init();
            });
    }
    upload = (version) => (e) => {
        let isOk = window.confirm("Are you sure? Have you saved the settings version?");
        if(!isOk)
            return;
        fetcher(`${config.API()}storage/versions/upload`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({version})
        })
            .then(response => response.json())
            .then(data => {
                this.init();
            });
    }

    exportObj = (version) => function (e){
        fetcher(`${config.API()}storage/versions/export`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({version})
        })
            .then(response => response.json())
            .then(data => {
                downloadFile(JSON.stringify(data, null, "\t"), `versions_${version}.json`, 'text/plain')
            });
    }

    render() {

        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }

        return (
            <div>
            <div className="card shadow w100">
                <div className="card-header py-3">
                    <h2 className="m-0 font-weight-bold l"> Versions, ServerVersion: <span className="font-weight-bold">{this.state.serverVersion}</span></h2>
                    <button onClick={this.createStorageVersion} className="btn btn-icon btn-primary ml-1 r"><i className="fas fa-fw fa-save"></i> SAVE ALL SETTINGS AS NEW VERSION</button>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="dataTable table table-align-middle table-bordered table-sm" width="100%"
                               cellSpacing="0">
                            <thead>
                            <tr className="small">
                                <th></th>
                                <th>Server (EnvID)</th>
                                <th>Ver</th>
                                <th>Parent</th>
                                <th>Creator</th>
                                <th>Applier</th>
                                <th>CreatedAt</th>
                                <th>AppliedAt</th>
                                <th>Changes</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.objects && _.orderBy(this.state.objects, "version", "desc").map((x,i) =>
                                <tr className={(x.currentAdmin ? "active" : "") + " small"} key={x._id} >
                                    <td>
                                        <i className={`fa ${x.currentAdmin ? "fa-check": ""}`}></i> {x.notSaved && <JsonEditorComponent mystyle="noBtn" text="NOT SAVED!" className="cp btn-danger" data={x.changes}/>}
                                    </td>
                                    <td>{x.serverVersion || ""}</td>
                                    <td><b>{x.version}</b></td>
                                    <td>{x.fromVersion || 0}</td>
                                    <td>{x.creator}</td>
                                    <td>{x.applier}</td>
                                    <td>{x.createdAt}</td>
                                    <td>{x.updatedAt}</td>
                                    <td>{x.changes && x.changes.length > 0 && <JsonEditorComponent mystyle="noBtn" className="cp" data={x.changes}/>}</td>
                                    <td>
                                        <button className="btn btn-outline-danger btn-circle btn-sm mr-2" onClick={this.remove(x.version)} title="Remove"><i className="fa fa-remove"></i></button>
                                        <button className="btn btn-outline-secondary btn-circle btn-sm mr-2" onClick={this.exportObj(x.version)} title="Export" ><i className="fas fa-file-export"></i></button>
                                        <button className="btn btn-warning btn-sm mr-2" onClick={this.upload(x.version)}><i className="fa fa-download"></i> Download to Admin</button>
                                        <button className="btn btn-danger btn-sm mr-2" onClick={this.applyToServer(x.version)} ><i className="fa fa-upload"></i> Upload to Server </button>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                     <div>
                        1. Делаем изменения. <br/>
                        2. Сохранаяем новую версию настроеек. <br/>
                        3. Выбираем с какой версией работать игровому-cерверу кнопкой Upload <br/>

                        Так же можем загрузить прошлую версию (Download), а дальше снова к пункту 1. <br/>

                         Для env кроме production включен режим autoSaveAndUpload.
                    </div>
                </div>
            </div>

            </div>
        );
    }
}
